module.exports = __webpack_public_path__ + "media/sounds/celebration-491a97d7b728588a14cf31e191687943.wav";